export default __webpack_public_path__ + "static/assets/aaa65571ab0f8c2f60e3998533595332.svg";